export default __webpack_public_path__ + "static/media/whiteShirt.bd8d03ac.png";